import useResponsive from '../../hooks/useResponsive';
import '../../css/richText/richText.css';

/**
 * Article, folder, pedagogical-content, and machine-section dialogs: use the
 * available viewport (full screen on phone, ~96vw × viewport on larger devices).
 */
const useContentFormDialog = () => {
    const isMobile = useResponsive('down', 'sm');

    return {
        fullScreen: Boolean(isMobile),
        fullWidth: true,
        maxWidth: false,
        scroll: 'paper',
        classes: { paper: 'contentFormDialog_paper' },
        PaperProps: {
            className: 'contentFormDialog_paper',
        },
    };
};

export default useContentFormDialog;
